// eslint-disable-next-line
import React, { useEffect } from "react";
import shareIcon from '../../images/share_32.svg';

// Function to escape HTML attributes
function escapeHtml(text: string): string {
  if (!text) return '';
  const map: { [key: string]: string } = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };
  return text.replace(/[&<>"']/g, function(m) { return map[m]; });
}

export default function ShareButtons(props: any) {
  const { shareData } = props;
  const { title, description, linkUrl, imageUrl } = shareData;

  const useNativeShare =
    !!navigator.share &&
    window.matchMedia('(pointer: coarse)').matches;

  useEffect(() => {
    if (!useNativeShare) {
      // @ts-ignore
      if (window.a2a && window.a2a.init_all) {
        // @ts-ignore
        window.a2a.init_all();
      }
    }
  }, [shareData, useNativeShare]);

  // Escape the data for HTML attributes
  const escapedTitle = escapeHtml(title || document.title);
  const escapedDescription = escapeHtml(description || '');

  const handleShare = async () => {
    try {
      await navigator.share({
        url: linkUrl || window.location.href,
        title: escapedTitle,
        text: escapedDescription
      })
    } catch (err) {
      console.debug('share cancelled or failed:', err);
    }
  }

  if (useNativeShare) {
    return (
      <img className="share-icon"
        src={shareIcon}
        onClick={handleShare}
      />
    )
  }

  return (
    <div className="a2a_kit a2a_kit_size_32 a2a_default_style"
      data-a2a-url={linkUrl || window.location.href}
      data-a2a-title={escapedTitle}
      data-a2a-description={escapedDescription}
      data-a2a-media={imageUrl || ''}
    >
      <a className="a2a_button_x"></a>
      <a className="a2a_button_facebook"></a>
      <a className="a2a_button_pinterest"></a>
      <a className="a2a_button_copy_link"></a>
    </div>
  )
}
